import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";

const HERO_IMG =
  "https://images.pexels.com/photos/4750315/pexels-photo-4750315.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

const fade = (delay) => ({
  initial: { opacity: 0, y: 22 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: [0.21, 0.47, 0.32, 0.98] },
});

export const Hero = () => {
  const { t } = useLang();
  const h = t.hero;

  return (
    <section id="home" className="relative pt-28 lg:pt-32 border-b border-border" data-testid="hero">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-y-12 lg:gap-x-12 items-stretch">
          {/* Left: text */}
          <div className="lg:col-span-6 flex flex-col justify-center py-12 lg:py-28">
            <motion.h1
              {...fade(0)}
              className="font-heading font-medium tracking-tighter text-nero-ink text-[3.25rem] leading-[0.96] sm:text-6xl lg:text-[5.5rem]"
              data-testid="hero-title"
            >
              {h.titleLine1}
              <br />
              <span className="text-nero-green">Green</span> Future.
            </motion.h1>

            <motion.p
              {...fade(0.12)}
              className="mt-8 max-w-xl font-body text-base sm:text-lg leading-relaxed text-zinc-600"
              data-testid="hero-subtitle"
            >
              {h.subtitle}
            </motion.p>

            <motion.div {...fade(0.24)} className="mt-12 grid grid-cols-3 max-w-lg border-t border-border">
              {h.stats.map((s, i) => (
                <div key={i} className={`py-6 ${i > 0 ? "pl-6 border-l border-border" : ""}`} data-testid={`hero-stat-${i}`}>
                  <div className="font-heading text-2xl lg:text-[1.75rem] font-medium tracking-tight text-nero-ink">
                    {s.value}
                  </div>
                  <div className="font-body text-xs lg:text-sm text-zinc-500 mt-1.5">{s.label}</div>
                </div>
              ))}
            </motion.div>
          </div>

          {/* Right: macro image */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-6 relative lg:border-l border-border"
          >
            <div className="relative h-72 sm:h-[420px] lg:h-full lg:min-h-[560px] overflow-hidden bg-nero-black">
              <img
                src={HERO_IMG}
                alt="Bio-Pflanzenkohle Makroaufnahme"
                className="w-full h-full object-cover"
                data-testid="hero-image"
              />
              <div className="absolute bottom-0 inset-x-0 flex items-center justify-between px-5 py-4 bg-white/85 backdrop-blur-md border-t border-border">
                <span className="font-heading text-sm font-medium text-nero-ink">{h.imageCaption}</span>
                <span className="font-body text-[0.7rem] uppercase tracking-[0.2em] text-zinc-500">{h.imageTag}</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
